export const integrations = [
  {
    name: 'Apollo LeadFinder',
    description: 'Discover and enrich qualified business leads so your sales team can focus on the right prospects.',
    category: 'Lead generation',
    icon: 'Users',
    color: 'text-violet-400',
    background: 'bg-violet-500/10',
    border: 'border-violet-400/20'
  },
  {
    name: 'Calendly',
    description: 'Let callers and leads book meetings automatically through your existing Calendly availability.',
    category: 'Scheduling',
    icon: 'Calendar',
    color: 'text-blue-400',
    background: 'bg-blue-500/10',
    border: 'border-blue-400/20'
  },
  {
    name: 'Cal.com',
    description: 'Connect flexible scheduling workflows and allow your AI receptionist to coordinate meetings 24/7.',
    category: 'Scheduling',
    icon: 'Clock',
    color: 'text-emerald-400',
    background: 'bg-emerald-500/10',
    border: 'border-emerald-400/20'
  },
  {
    name: 'Google Calendar',
    description: 'Check availability, create appointments, and keep your calendar in sync after every qualified call.',
    category: 'Calendar',
    icon: 'CalendarCheck',
    color: 'text-amber-400',
    background: 'bg-amber-500/10',
    border: 'border-amber-400/20'
  },
  {
    name: 'Zapier',
    description: 'Connect AutoReception to thousands of apps and automate the workflows that move your business forward.',
    category: 'Automation',
    icon: 'Zap',
    color: 'text-orange-400',
    background: 'bg-orange-500/10',
    border: 'border-orange-400/20'
  },
  {
    name: 'WooCommerce',
    description: 'Route customer questions, order-related calls, and support requests into your WooCommerce workflow.',
    category: 'E-commerce',
    icon: 'ShoppingCart',
    color: 'text-pink-400',
    background: 'bg-pink-500/10',
    border: 'border-pink-400/20'
  }
];